// import styled from "styled-components";
import Atlas from "../components/Atlas/Atlas.js";
import Nav from "../components/Nav/Nav.js"

export default function AtlasPage() {

    return (
        <>
            <Nav/>
            <Atlas />
        </>
    )
}
